export enum EnumMemberStatus {
  APPLIED = 'applied',
  MEMBER = 'member',
}
